<template>
    <transition name="fade">
        <div component="VideoGalleryRecorder" v-if="visible" v-click-outside="clickOutside">
            <btn class="close" color="ghostWhite" size="icon" :icon="'close'" @click.stop="close" />
            <video-recorder :uploading="uploading" :message="response" @submit="upload"></video-recorder>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ClickOutside from 'vue-click-outside';
import VideoRecorder, { defaultVrMessage } from '@/components/Profile/Video/VideoRecorder.vue';
import { ActorPortfolioModel } from '@/model';
import { ActorsApi } from '@/api';

export default {
    name: 'VideoGalleryRecorder',

    components: {
        VideoRecorder,
    },

    directives: {
        ClickOutside,
    },

    data: () => ({
        visible: false,
        uploading: false,
        response: {
            visible: false,
            message: '',
            error: false,
        },
    }),

    created() {
        this.$_eventsSubscribe({ openVideoPortfolioRecorder: 'open' });
    },

    beforeDestroy() {
        this.$_eventsUnsubscribe();
    },

    methods: {
        // Used as event listener, don't remove
        open() {
            this.visible = true;
        },

        close() {
            this.visible = false;
        },

        async upload(file) {
            this.uploading = true;
            try {
                const { data } = await ActorsApi.createActorPortfolio(
                    this.getActor,
                    {
                        file_type: 'video',
                        nazov: file.name.split('.')[0],
                        poradie: 0,
                    },
                    file
                );

                const record = new ActorPortfolioModel(data);

                this.getActor.addPortfolioItem(record);
                this.response = {
                    ...defaultVrMessage,
                    visible: true,
                    message: 'Video was successfuly uploaded and processing in background.',
                };
                this.$_eventsDispatch('videoPortfolioItemCreated', record);
                setTimeout(() => {
                    this.close();
                }, 3000);
            } catch (e) {
                this.response = {
                    ...defaultVrMessage,
                    visible: true,
                    message: 'Error while uploading video, try again.',
                    error: true,
                };
                this.$env.log.error(e);
                this.$bugsnag.notify(e);
            } finally {
                this.uploading = false;
            }
        },

        clickOutside() {
            // this.close(); // Not Working
        },
    },

    computed: {
        ...mapGetters(['getActor']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';
[component='VideoGalleryRecorder'] {
    .flex-center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5555;
    width: 100%;
    height: 100%;
    background: black;
    border-radius: 20px;

    &.fade-enter-active,
    &.fade-leave-active {
        transition: 0.5s;
    }
    &.fade-enter, &.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: scale(0.9);
    }

    video {
        width: 100%;
        height: 100%;
    }

    .close {
        position: absolute;
        right: 10px;
        top: 10px;
        box-shadow: 0 0 20px 6px black;
        background: rgba(0, 0, 0, 0.3) !important;
        z-index: 9999;
    }
}
</style>
